import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEraser,
  faPencilAlt,
  faPlusSquare,
  faFileAlt
  
} from "@fortawesome/free-solid-svg-icons";
import { hoverTips } from "utils/mixin";

const StyledTool = styled.div`
  display: inline-block;
  padding: 2px 5px;
  cursor: pointer;
  color: ${({ theme }) => theme.black};
  opacity: 0.7;
  transition: 0.2s;

  ${({ theme, tips, titlePosition }) =>
    hoverTips(theme, tips, titlePosition.left, titlePosition.top)};

  :hover {
    color: ${({ theme }) => theme.dark};
    opacity: 1;
  }
`;

const tools = {
  add: {
    label: "添加",
    icon: faPlusSquare,
    authRequired: true
  },
  remove: {
    label: "删除",
    icon: faEraser,
    authRequired: true
  },
  update: {
    label: "修改",
    icon: faPencilAlt,
    authRequired: true
  },
  detail: {
    label: "详情",
    icon: faFileAlt,
    authRequired: false
  }
};

const Tool = ({
  auth = false,
  type,
  size,
  title = "",
  titlePosition = { left: "-50%", top: "-90%" },
  onClick = () => {},
  data,
}) => {

  // 如果需要权限 并且没有权限时 返回空
  if(tools[type].authRequired && !auth) {
    return null;
  }

  return (
    <StyledTool
      tips={title ? title : tools[type].label}
      titlePosition={titlePosition}
      onClick={(e) => {
        //阻止事件进一步传播
        e.stopPropagation();
        onClick(data);
      }}
    >
      <FontAwesomeIcon icon={tools[type].icon} size={size} />
    </StyledTool>
  );
};

Tool.propTypes = {
  type: PropTypes.oneOf(["add", "remove", "update", "detail"]),
};

export default Tool;
